// eslint-disable-next-line no-console
export const log = (message: string) => console.log(message);
